export default "<h4 class=\"animate__animated animate__hearbeat animate__infinite\">\n  BOOM\n</h4>";